/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable camelcase */
/* eslint-disable no-console */
import React from "react";
import PropTypes from "prop-types";

function Toppings(props) {
  const { toppings } = props;
  const occurances = toppings != null ? toppings.reduce((sums, topping) => {
    // eslint-disable-next-line no-param-reassign
    sums[topping.name] = (sums[topping.name] || 0) + 1;
    return sums;
  }, {}) : {};
  const toppingStr = Object.keys(occurances)
    .map((topping) => `${occurances[topping]}x ${topping}`)
    .join(", ");
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {toppingStr.length === 0 ? "No toppings added" : toppingStr}
    </>
  );
}

Toppings.propTypes = {
  toppings: PropTypes.arrayOf(
    PropTypes.shape({
      item_id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

Toppings.defaultProps = {
  toppings: [],
};

export default Toppings;
